// extracted by mini-css-extract-plugin
export var animationContainer = "_id-0";
export var asteriskIcon = "_id-8";
export var conversationLeftSection = "_id-4";
export var conversationListItem = "_id-3";
export var conversationMiddleSection = "_id-5";
export var conversationRightSection = "_id-6";
export var detailsContent = "_id-1";
export var listContainer = "_id-7";
export var modalContent = "_id-2";